import React from "react";
import { translate } from "../Services/translation";

const BuyButton = ({
  label,
  articleNumber,
  quantityFieldId,
  href,
  cssClass,
  onClick,
  showLabel,
  isInStock,
}) => {
  var buyable = true;

  if (cssClass === null) {
    cssClass = "button buy-button product-detail__buy-button";
  }
  if (label === null) {
    label = translate("product.buy");
    }

    const toggleUpsellVisibility = () => {
        const upsellContainer = document.getElementById("upsell-products");

        if (upsellContainer) {
            if (upsellContainer.classList.contains("hidden")) {
                // Remove 'hidden' class and add 'visible' after a small delay to ensure CSS transition works
                upsellContainer.classList.remove("hidden");

                requestAnimationFrame(() => {
                    upsellContainer.classList.add("visible");
                });
            } 
        }
    };

  return articleNumber && buyable ? (
    <a
      className={cssClass}
      onClick={() => {
        // Call the passed-in onClick handler
        if (onClick) {
          onClick(articleNumber, quantityFieldId);
        }
        // Toggle visibility of upsell products
        toggleUpsellVisibility();
      }}
    >
      <div>
        <i className="icon ion-md-cart product-detail__buy-button--icon"></i>
        {(showLabel === "True" || showLabel === true) && (
          <span className="product-detail__buy-button--label">{label}</span>
        )}
      </div>
    </a>
  ) : href ? (
    <a
      className={cssClass}
      href={href}
      onClick={() => {
        window.location.href = href;
      }}
    >
      <span className="product-detail__buy-button--label">{label}</span>
    </a>
  ) : (
    <a className={cssClass}>
      <span className="product-detail__buy-button--label">{label}</span>
    </a>
  );
};

export default BuyButton;
